module.exports = __webpack_public_path__ + "img/2015-11-14.ef1167a8.jpg";